export enum MyOrdersQASelectors {
    ORDER_CARD = 'order-card',
    DETAILS = 'details',
    ORDER_DETAILS = 'order-details',
    ORDER_DETAILS_STATUS = 'order-details-status',
    ORDER_DETAILS_INVENTORY = 'order-details-inventory',
    ORDER_DETAILS_TICKETS = 'order-details-tickets',
    ORDER_DETAILS_TICKET_CATAGORY = 'order-details-ticket-catagory',
    ORDER_DETAILS_TICKET_PRICE = 'order-details-ticket-price',
    ORDER_DETAILS_REQUIRED_INVOICE = 'order-details-required-invoice',
    ORDER_DETAILS_DELIVERY = 'order-details-delivery',
    ORDER_DETAILS_PAYMENT = 'order-details-payment',
    ORDER_DETAILS_OVERVIEW = 'order-details-overview',
    ORDER_DETAILS_TICKET_POSITION = 'order-details-ticket-position',
}